import { render, staticRenderFns } from "./AboutPageCeo.vue?vue&type=template&id=2481fce0&scoped=true"
import script from "./AboutPageCeo.vue?vue&type=script&lang=ts"
export * from "./AboutPageCeo.vue?vue&type=script&lang=ts"
import style0 from "./AboutPageCeo.vue?vue&type=style&index=0&id=2481fce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481fce0",
  null
  
)

export default component.exports